<div id="c-landing">
  <ng-container *ngIf="isLoaded">
    <div class="network-class" [ngClass]="{'brand-wtg' : params.network && params.network == 16, 'brand-geo' : params.network && params.network == 46}">
      <div class="top-bar-menu p-0" *ngIf="params.network && params.network == 16 && params.pageType !== 'cataloghi'">
        <div class="container container-lg">
          <nav class="navbar navbar-expand-lg p-0">
            <div class="top-bar-menu__logo py-1">
              <span>Agenzia partner di:</span>
              <img src="./assets/images/welcome_logo_negative.png" height="30" alt="Welcome Travel Group">
            </div>
          </nav>
        </div>
      </div>
      <div class="c-landing__header">
        <div class="container container-lg logo-network-fit">
          <div class="logo agency-logo">
            <img src="{{this.agencyInfo.logo}}" alt="Logo" *ngIf="this.agencyInfo.logo?.length > 12">
            <h2 *ngIf="this.agencyInfo.logo?.length <= 12">{{this.agencyInfo.denominazione}}</h2>
          </div>
          <div class="logo network-logo">
            <img *ngIf="params.network && params.network == 46" src="./assets/images/geo_logo.png" alt="Network Logo" />
            <img *ngIf="params.network && params.network == 16" src="./assets/images/welcome_logo.png" alt="Network Logo" />
          </div>
        </div>

      </div>
      <router-outlet></router-outlet>
      <div class="c-landing__footer">
        <div class="container container-lg">
          <div class="agency-info left-pane">
            <h4>{{this.agencyInfo.denominazione}}</h4>
            <div class="contacts">
              <div class="c-landing__icon-label" *ngIf="this.agencyInfo.email1"><i class="icon-email"></i><span>{{this.agencyInfo.email1}}</span></div>
              <div class="c-landing__icon-label" *ngIf="this.agencyInfo.tel1"><i class="icon-phone-shape"></i><span>{{this.agencyInfo.tel1}}</span></div>
            </div>
          </div>
          <div class="website right-pane">
            <ng-container *ngIf="this.agencyInfo.sito">
              <h4>Visita il nostro sito web</h4>
              <a class="site-link" [href]="this.agencyInfo.sito.includes('http') ? this.agencyInfo.sito : '//' + this.agencyInfo.sito" target="_blank">{{this.agencyInfo.sito}}</a>
            </ng-container>
          </div>

        </div>

      </div>
    </div>
  </ng-container>

</div>



